export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "bundle.mon-metrics-download.worker.a166f481096c7ddd3483.worker.js");
}
